import { IBecomeSustainable } from '@/store/modules/becomeSustainable/interfaces/IBecomeSustainable'
import { IBecomeSustainableState } from '@/store/modules/becomeSustainable/interfaces/IBecomeSustainableState'
import { IBecomeSustainableContent } from '@/store/modules/becomeSustainable/interfaces/IBecomeSustainableContent'
import { BecomeSustainableActionType } from '@/store/modules/becomeSustainable/interfaces/action-type'
import { becomeSustainableApi } from '@/store/modules/becomeSustainable/api'

const state = (): IBecomeSustainableState => ({
  sustainableCategories: [],
  sustainableContent: [],
  sustainableLandingPage: {} as IBecomeSustainable,
  surveyPage: {} as IBecomeSustainable,
  loading: false
})

const mutations = {
  setLoadingBecomeSustainable (state: IBecomeSustainableState, payload: boolean) {
    state.loading = payload
  },

  async setCategoriesBecomeSustainable (state: IBecomeSustainableState, payload: IBecomeSustainable[]) {
    const filtered = payload.filter(
      (category) => category.location === 'Category'
    )
    state.sustainableCategories = filtered.sort((a, b) => {
      let aPosition = 0
      let bPosition = 0
      if (a.position) {
        aPosition = isNaN(parseInt(a.position, 10)) ? 0 : parseInt(a.position)
      }
      if (b.position) {
        bPosition = isNaN(parseInt(b.position, 10)) ? 0 : parseInt(b.position)
      }
      return aPosition - bPosition
    })
    state.sustainableLandingPage =
      payload.find((content) => content.location === 'LandingPage') || ({} as IBecomeSustainable)
    state.surveyPage =
      payload.find((content) => content.location === 'Checklist') || ({} as IBecomeSustainable)
  },

  async setContentBecomeSustainable (state: IBecomeSustainableState, payload: IBecomeSustainableContent[]) {
    state.sustainableContent = payload
  }
}

const actions = {
  async [BecomeSustainableActionType.FETCH_BECOME_SUSTAINABLE] ({ state, commit, rootState }: any) {
    commit('setLoadingBecomeSustainable', true)
    let categories: IBecomeSustainable[] = []
    let content: IBecomeSustainableContent[] = []
    //  if (      rootState?.auth?.user?.isLoggedIn    ) {
    categories = await becomeSustainableApi.getBecomeSustainable()
    content = await becomeSustainableApi.getBecomeSustainableContent()

    commit('setCategoriesBecomeSustainable', categories)
    commit('setContentBecomeSustainable', content)
    commit('setLoadingBecomeSustainable', false)
    return { categories, content }
    // }
  }
}

const BecomeSustainableModule = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default BecomeSustainableModule
